import messages from '../locales/da_DK.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'da-DK',
};
export default lang;
